import { render, staticRenderFns } from "./LanguageSelection.vue?vue&type=template&id=8181a538&"
import script from "./LanguageSelection.vue?vue&type=script&lang=js&"
export * from "./LanguageSelection.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSelection.vue?vue&type=style&index=0&id=8181a538&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports